import React from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import {
   Container,
   Header,
   Button,
   Icon,
   Divider,
   Tab,
} from 'semantic-ui-react'
import { withFirebase } from '../Firebase'
import form from './config/workflow-form'
import { AutoLabel } from '../Common'
import { TabWidget } from '../Widgets'
import TableComponent from '../Table'
import labels from '../Common/translations'
import list from './config/workflow-list'
import { labelHelper } from '../Helpers'

class InspectionShowPage extends React.Component {
   constructor(props) {
      super(props)
      this.state = { open: false }
      this.goBack = this.goBack.bind(this)
      this.modalRef = React.createRef()
   }

   lb = new labelHelper(
      labels,
      this.props.authUser ? this.props.authUser.lang : labelHelper.lang
   )

   async componentDidMount() {
      this.setState({ loading: true })
      const { data: item } = await form.actions.read(this.props.match.params.id)

      this.setState({
         item,
         loading: false,
      })
   }

   goBack() {
      this.props.history.goBack()
   }

   panes = [
      {
         key: 'workflows',
         menuItem: this.lb._(labels.screens.workflows),
         render: () => (
            <Tab.Pane key="workflows">
               <TableComponent list={list} {...this.props} />
            </Tab.Pane>
         ),
      },
      {
         key: 'medias',
         menuItem: this.lb._(labels.screens.medias),
         render: () => (
            <Tab.Pane key="pendingInspections">
               <TableComponent
                  list={list}
                  filters={{
                     ...this.filters(),
                  }}
                  {...this.props}
               />
            </Tab.Pane>
         ),
      },
   ]

   render() {
      if (!this.state.item) {
         return <div />
      }

      const {
         item: { name },
      } = this.state

      return (
         <Container>
            <Container>
               <Header as="h1">{name}</Header>
               <Button primary icon labelPosition="left" onClick={this.goBack}>
                  <Icon name="left arrow" />
                  <AutoLabel labelKey="form.back" />
               </Button>
               <Divider />
               <Container>
                  <TabWidget panes={this.panes} />
               </Container>
            </Container>
         </Container>
      )
   }
}

export default compose(withRouter, withFirebase)(InspectionShowPage)
